const Content = () => {
  return (
    <div className="content">
      <p>
        عدم کنترل پسماند و زباله ها در مناطق صنعتی، شرکت ها و مناطق شهری باعث
        افزایش روز افزون زیانهای بهداشتی و اقتصادی گردیده است و روزانه به حجم
        انباشته شدن این زباله ها و پسماند ها در این مناطق افزوده می شود و
        متاسفانه هزینه های گزافی را جهت جمع آوری و دفع آنها به بار می آورد. لذا
        اگر این زباله ها و پسماندها قبل از اینکه روی هم انباشته شوند، از هم
        تفکیک -شوند و با جداسازی بهنگام و درست بازیافت شوند، عملیات بازیافت موفق
        آمیز تر صورت خواهد گرفت. پس باید در جهت جمع آوری و دفع آنها گامهای اساسی
        و موثری در زمینه کنترل پسماندها برداشت. در کشور ما از دیر باز نان را از
        زباله ها تفکیک می کردند ولی در زمینه تفکیک زباله های تر و خشک و دیگر
        زباله ها بتازگی اقداماتی صورت گرفته که البته هنوز جای کار بیشتری دارد.
        در بحث جداسازی زباله های صنعتی و بیمارستانی از زباله های شهری از اهمیت
        بیشتری برخوردار است و با توجه به رشد جمعیت و کاهش منابع طبیعی موضوع
        بازیافت زباله از الزامات شهرهای بزرگ و صنعتی گردیده است. بنابراین اولین
        قدم برای این کار جداسازی زباله ها بر اساس نوع زباله می باشد.
      </p>
      <div className="faq">
        <h4>سوالات متداول</h4>
        <h5>تفکیک زباله چیست ؟</h5>
        <p>
          تفکیک زباله به فرآیندی گفته می‌شود که طی آن عملیات جداسازی و یا دسته
          بندی انواع مختلف زباله‌ها صورت گیرد و از طریق آن پسماندها به عناصر
          متنوعی تبدیل و تفکیک خواهند شد.
        </p>
        <h5>هدف تفکیک زباله چیست ؟</h5>
        <p>
          اصلی‌ترین هدف از تفکیک زباله، پیشگیری از آلودگی محیط زیست است. این
          فرآیند کمک می‌کند تا مواد قابل بازیافت جمع آوری شده و دوباره به چرخه
          طبیعت بازگردانده شوند.
        </p>
        <h5>مزایا و معایب تفکیک زباله چیست ؟</h5>
        <p>
          مزایای تفکیک زباله بسیار زیاد است و مهم ترین آن ، دسته بندی پسماندها
          به صورت خشک و تر است. تفکیک زباله تنها عیبی که دارد این است که در بعضی
          از کشورها کارکنان کارخانجات بازیافت، در تماس با بسیاری از مواد سمی و
          یا شیمیایی قرار می گیرند.
        </p>
        <h5>بازیافت زباله چه فایده‌ای دارد ؟</h5>
        <p>
          کمک به کاهش آلودگی‌های زیست محیطی - صرفه جویی در منابع - حفظ و نگهداری
          محیط زیست - کمک به کاهش گرمای زمین - کاهش میزان زباله‌ها در محل دفن
        </p>
        <h5>تفکیک زباله از مبدا یعنی چه ؟</h5>
        <p>
          این شیوه فرایند تفکیک زباله‌ها از یکدیگر در خانه، ادارات و فروشگاه ها
          صورت پذیرفته و این پسماندها از همان ابتدا دسته بندی می‌شوند.
        </p>
        <h5>زباله های خشک و تر را نام ببرید؟</h5>
        <p>
          زباله های خشک شامل پسماند کاغذ ، پسماند ظروف شیشه‌ای و بطری‌ها ،
          پسماند قوطی‌های فلزی ، زباله های تر شامل پسماند های میوه و سبزیجات،
          پسماند انواع مواد غذایی، تفاله چای
        </p>
      </div>
    </div>
  );
};

export default Content;
